import {apiSlice} from "store/slices/apis/apiSlice";
const scheduleApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        startScheduleWorkflow: builder.mutation({
            query: ({projectId, scheduleDetail, files, type}) => {
                const formData = new FormData();
                formData.append("type", type);
                formData.append("file", files[0]);
                formData.append("description", scheduleDetail);
                if (projectId) {
                    formData.append("projectId", projectId);
                }
                return {
                    url: "/masterschedule",
                    method: "POST",
                    body: formData,
                };
            },
        }),
        approveWorkflowTask: builder.mutation({
            query: ({id,body}) => ({
                url: `masterschedule/${id}/approve`,
                method: 'POST',
                body 
            }),
            invalidateTags: ["My-WorkFlow"],
        }),
        rejectWorkflowTask: builder.mutation({
            query: ({id,body}) => ({
                url: `masterschedule/${id}/reject`,
                method: 'POST',
                body 
            }),
            invalidateTags: ["My-WorkFlow"],
        }),
        getAllImplementationSchedule: builder.query({
            query: ({type}) => ({
                url: `masterschedule?type=${type}`,
            }),
            providesTags: ["MasterSchedule"],
        }),
        getImplementationScheduleDetail: builder.query({
            query: ({id}) => ({
                url: `masterschedule/${id}`,
            }),
            providesTags: ["MasterSchedule"],
        }),
        getImplementationScheduleDocuments: builder.query({
            query: ({type,id}) => ({
                url: `FileUpload/entity/${type}/${id}`
            }),
            providesTags: ["MasterSchedule"],
        }),

    }), 

});
export const { useStartScheduleWorkflowMutation, useApproveWorkflowTaskMutation, useGetAllImplementationScheduleQuery, useGetImplementationScheduleDetailQuery, useGetImplementationScheduleDocumentsQuery, useRejectWorkflowTaskMutation } = scheduleApiSlice;